// Retrieve the R channel of an RGBA drawing
export const getRChannel = (canvas, width, height=width) => {
  // This method retrieves the RGBA channels of a canvas. Hence, the size of the
  // array is  equal to `width` * `width` * 4. Since the images are in gray-scale
  // format, all channels (except for A, which is always 255 - i.e., visible) are
  // equal. Thus we only retrieve the R-channel for faster processing
  return canvas
    .getContext('2d')
    .getImageData(0, 0, width, height)
    .data
    .filter((_, i) => i % 4 === 0) // Only retrieve R-channel
}
